import { Collapse, Button, Popconfirm, Card, Tag } from "antd";
import { Affirmative, Fallback, Journey, ICreateNode, IUpdateNode, IDeleteNode, IJourneyLevel, EventProperty } from "../utils/types";
import styled from "styled-components";
import AffirmationFallbackCreate from "./AffirmationFallbackForm";
import React, { useRef } from "react";
import JourneyForm from "./JourneyForm";
import { IMAGE_TYPES, LANGUAGE_TYPES, NUMBER_TYPES, TEMPLATE_TYPES, URL_TYPES } from "../utils/contants";
import { Image } from 'antd';
import { NEW_CDN_HOST } from "../../../../../utils/constants";

const StyledTr = styled.tr`
  &:nth-child(even) {
    background-color: #dddddd;
  }
`
const StyledTable = styled.table`
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
`

const StyledTd = styled.td`
  border: 1px solid #dddddd;
  text-align: left;
  padding: 4px 8px;
  text-align: center;
`
const StyledTh = styled.td`
  border: 1px solid #dddddd;
  text-align: left;
  padding: 4px 8px;
  text-align: center;
`

const LevelContainer = styled.div`
    justify-content: space-between;
    display: flex;
    flex-direction: row-reverse;
    width: 100%;
    z-index: 10;
    & > div {
      width: 49%;
    }
    background-color: white;
    margin-top: 5px;
`

const CollapseCustomHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    column-gap: 10px;
    width: 100%;
    & div {
      margin-left: 10px;
      margin-right: auto;
      font-size: 20px;
    }
`

const StyledClollapsePanel = styled(Collapse.Panel)`
    & .ant-collapse-header {
      align-items: center !important;
    }
`

const StyledCollapseContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
`

const ArrowContainer = styled.div`
    display: flex;
    height: 100px;
    padding-left: 20%;
    &>svg{
      overflow: visible;
    }
`;

const OptionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    width: 100%;
    border: 1px solid #dddddd;
    padding: 10px;
    border-radius: 5px;
`;

const redColor = '#c9b3b3';
const greenColor = '#ccd1cc';


const renderCollapseHeader = (name: string, identifier: [number, number], deleteNode: IDeleteNode, updateEditUuid: (identifier: [number, number]) => void, level: number) => {
  return <CollapseCustomHeader>
    <div>{name}</div>
    {
      identifier.toString() !== '-1,-1' && <>
        <Button type="link" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          updateEditUuid(identifier);
        }}
        >Edit</Button>
        {
          (level > 1 || identifier.toString() === '1,0') && <Popconfirm
            placement="top"
            title={"Are you sure you want to delete this node?"}
            onConfirm={(e) => {
              if (e) {
                e.preventDefault();
                e.stopPropagation();
              }

              deleteNode(identifier)
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" >Delete</Button>
          </Popconfirm>
        }
      </>
    }

  </CollapseCustomHeader>
}

const RenderNode = (props: { node: Journey | Affirmative | Fallback, type: 'affirmative' | 'fallback', updateNode: IUpdateNode, deleteNode: IDeleteNode, level: number }) => {
  const { node, type, deleteNode, updateNode, level } = props;
  const { name, event_schema } = node;
  const nudge = 'nudge' in node ? node.nudge : undefined;
  const cohort = 'cohort' in node ? node.cohort : undefined;
  const [editIdentifier, setEditIdentifier] = React.useState<[number, number]>();
  const updateEditIdentifier = React.useCallback((identifier?: [number, number]) => {
    setEditIdentifier(identifier);
  }, [])


  if (editIdentifier) {
    if (editIdentifier.toString() === '0,1') {
      return <JourneyForm
        onUpdate={updateNode}
        updateEditIdentifier={updateEditIdentifier}
        journey={node as Journey} />
    }
    return <AffirmationFallbackCreate
      background={type === "affirmative" ? greenColor : redColor}
      type={type}
      updateEditIdentifier={updateEditIdentifier}
      node={node}
      parentIdentifier={editIdentifier}
      onUpdate={updateNode}
    />
  }
  return <Collapse style={{ width: '100%', overflow: "scroll", borderTop: `1px solid ${type === "affirmative" ? greenColor : redColor}` }}>
    <StyledClollapsePanel header={renderCollapseHeader(name, node.identifier, deleteNode, updateEditIdentifier, level)} key="1">
      <StyledCollapseContent>
        <span><strong>Name </strong>: {node.name}  </span>
        {
          level === 0 &&
          <span><strong>Run parallel always </strong>: {'run_parallel_always' in node && (node.run_parallel_always ?
            <Tag color="green">Yes </Tag> : <Tag color="red"> No </Tag>)}
          </span>
        }
        {
          'priority' in node && node.priority &&
          <span><strong>Priority </strong>: {node.priority}  </span>
        }

        {'timeout_interval' in node && node.timeout_interval &&
          <span><strong>Timeout </strong>: {node.timeout_interval}  miliseconds </span>}
        {cohort && <>
          <div>
            <span><b>Entry day since install </b>: {cohort.entry_properties.length > 0 && cohort.entry_properties[0].value_int64} </span>
            , &nbsp;<span><b>Exit day since install </b>: {cohort.exit_properties.length > 0 && cohort.exit_properties[0].value_int64}  </span>
          </div>
          {
            cohort?.entry_properties?.length > 1 && <StyledTable >
              <thead>
                <StyledTr>
                  <StyledTh>Path</StyledTh>
                  <StyledTh>Operator</StyledTh>
                  <StyledTh>Value </StyledTh>
                </StyledTr>
                {cohort?.entry_properties?.map((item: EventProperty, index) => {
                  if (index === 0) return null;
                  return <StyledTr>
                    <StyledTd>{item.path}</StyledTd>
                    <StyledTd>{item.operator}</StyledTd>
                    <StyledTd>{item.value_int64}</StyledTd>
                  </StyledTr>
                })}
              </thead>
            </StyledTable>
          }
        </>
        }
        <span><strong>Event name </strong>: {event_schema.event_name}  </span>
        {
          event_schema?.properties?.length > 0 && <StyledTable >
            <thead>
              <StyledTr>
                <StyledTh>Path</StyledTh>
                <StyledTh>Operator</StyledTh>
                <StyledTh>Value</StyledTh>
              </StyledTr>
              {event_schema?.properties?.map((item: EventProperty) => {
                return <StyledTr>
                  <StyledTd>{item.path}</StyledTd>
                  <StyledTd>{item.operator}</StyledTd>
                  <StyledTd>{item.value_int64 || item.value_string}</StyledTd>
                </StyledTr>
              })}
            </thead>
          </StyledTable>
        }

        {nudge?.template && <span><strong>Nudge template </strong>: {nudge.template}  </span>}
        {nudge?.page_tag && <span><strong>Page tag </strong>: {nudge.page_tag}  </span>}
        {nudge?.anchor_tag && <span><strong>Ancher tag </strong>: {nudge.anchor_tag}  </span>}
        {!!nudge?.wait_interval_millis && <span><strong>Wait interval millis </strong>: {nudge.wait_interval_millis}  </span>}
        {
          nudge && nudge.attributes && Object.keys(nudge.attributes).map((attribute) => {

            switch (true) {
              case URL_TYPES.has(attribute):
                return <span><strong>{attribute} </strong>: <a href={nudge.attributes[attribute]}>{nudge.attributes[attribute]}</a></span>
              case LANGUAGE_TYPES.has(attribute):

                const languages: string[] = Object.keys(nudge['attributes'][attribute])
                const languageTexts: string[] = Object.values(nudge['attributes'][attribute])
                return <div>
                  <span><strong>{attribute} </strong></span>
                  <StyledTable >
                    <thead>
                      {
                        languages.map((language) => {
                          return <StyledTh key={language}>{language}</StyledTh>
                        })
                      }

                    </thead>
                    <StyledTr>
                      {
                        languageTexts.map((languageText) => {
                          return <StyledTd >{languageText}</StyledTd>
                        })
                      }
                    </StyledTr>
                  </StyledTable>
                </div>
              case IMAGE_TYPES.has(attribute):
                return <span><strong>{attribute} </strong>: <Image
                  width={100}
                  src={NEW_CDN_HOST + '/' + nudge.attributes[attribute]}
                /></span>;
              case NUMBER_TYPES.has(attribute):
                return <span><strong>{attribute} </strong>: {nudge.attributes[attribute]}</span>
              case TEMPLATE_TYPES.has(attribute):
                return <Card>
                  <h2> Questions </h2>
                  {
                    nudge.attributes[attribute].map((question: any) => {
                      const titleLanguages: string[] = Object.keys(question['title'])
                      const titleLanguageTexts: string[] = Object.values(question['title'])
                      const options = question.options || [];
                      const placeholders = question.placeholder || {};
                      console.log(placeholders, "placeholders", question)
                      const placeholderLanguagesKeys: string[] = Object.keys(placeholders)
                      const placeholderLanguagesTexts: string[] = Object.values(placeholders)
                      return <><OptionsContainer >
                        {<div><strong>Code  </strong>: {question.code}  </div>}
                        {<div><strong>Type  </strong>: {question.type}  </div>}
                        <div>
                          <span><strong>Title </strong></span>
                          <StyledTable >
                            <thead>
                              {
                                titleLanguages.map((language) => {
                                  return <StyledTh key={language}>{language}</StyledTh>
                                })
                              }
                            </thead>
                            <StyledTr>
                              {
                                titleLanguageTexts.map((languageText) => {
                                  return <StyledTd >{languageText}</StyledTd>
                                })
                              }
                            </StyledTr>
                          </StyledTable>
                        </div>
                        <div>
                          {
                            options.length > 0 && <>
                              {options.map((option: any, index: number) => {
                                const optionLanguages: string[] = Object.keys(option)
                                const optionLanguageTexts: string[] = Object.values(option)
                                return <>
                                  <span><strong> Option {index += 1} </strong></span>
                                  <StyledTable >
                                    <thead>
                                      {
                                        optionLanguages.map((language) => {
                                          return <StyledTh key={language}>{language}</StyledTh>
                                        })
                                      }
                                    </thead>
                                    <StyledTr>
                                      {
                                        optionLanguageTexts.map((languageText) => {
                                          return <StyledTd >{languageText}</StyledTd>
                                        })
                                      }
                                    </StyledTr>
                                  </StyledTable>
                                </>
                              })}
                            </>
                          }
                        </div>
                        <div>
                          {
                            placeholderLanguagesKeys.length > 0 && <>
                              <span><strong>Placeholders </strong></span>
                              <StyledTable >
                                <thead>
                                  {
                                    placeholderLanguagesKeys.map((language) => {
                                      return <StyledTh key={language}>{language}</StyledTh>
                                    })
                                  }
                                </thead>
                                <StyledTr>
                                  {
                                    placeholderLanguagesTexts.map((languageText) => {
                                      return <StyledTd >{languageText}</StyledTd>
                                    })
                                  }
                                </StyledTr>
                              </StyledTable>
                            </>
                          }
                        </div>
                        {question.limit && <div><strong>Limit  </strong>: {question.limit}  </div>}
                      </OptionsContainer>

                        <div style={{ height: '10px' }}>

                        </div>
                      </>
                    })
                  }
                </Card>
              default:
                return null;
            }
          })
        }
        {'trigger_count_cap' in node && <span><strong>Trigger count cap </strong>: {node.trigger_count_cap}  </span>}
      </StyledCollapseContent>
    </StyledClollapsePanel>
  </Collapse>
}

interface JourneyNodeProps {
  row: IJourneyLevel;
  nextRow?: IJourneyLevel;
  createNode: ICreateNode;
  updateNode: IUpdateNode;
  deleteNode: IDeleteNode;
  level: number;
  newAffirmativeParent?: [number, number];
}
const JourneyLevel = function (props: JourneyNodeProps) {
  const { row, createNode, updateNode, deleteNode, level = 0, newAffirmativeParent, nextRow } = props;
  const levelNode = useRef(null);
  const affirmativeLine = useRef(null);
  const fallbackLine = useRef(null);

  const affirmative = row[1];
  const isViewOnly = () => {
    if (affirmative && affirmative.identifier && affirmative.identifier.toString() !== '-1,-1') return true;
  }
  const fallback = row[0];

  const nextAffirmative = nextRow && nextRow[1];
  const nextFallback = nextRow && nextRow[0];

  if (!affirmative) {
    if (affirmative === null) {
      return <LevelContainer >
        <div></div>
        <div>
          <AffirmationFallbackCreate background={greenColor} type={"affirmative"} onCreate={createNode} parentIdentifier={[level - 1, 1]} />
        </div>
      </LevelContainer>
    } else {
      if (newAffirmativeParent) {
        return <LevelContainer >
          <div></div>
          <div><Button
            type="link"
            style={{ color: 'green', marginTop: '100px' }}
            onClick={() => { createNode(newAffirmativeParent, { type: 'affirmative', values: null }) }}
          > Create affirmative </Button></div>
        </LevelContainer>
      } else {
        return null;
      }
    }
  };
  return <div onClick={() => {
    setTimeout(() => {
      if (levelNode.current && affirmativeLine.current && fallbackLine.current) {
        // @ts-ignore
        const affirmativeNode = levelNode.current.children[0].children[1].children[0];
        // @ts-ignore
        const fallbackNode = levelNode.current.children[0].children[0].children[0];
        if (affirmativeNode && fallbackNode && affirmativeNode.clientHeight < fallbackNode.clientHeight) {
          const diff = fallbackNode.clientHeight - affirmativeNode.clientHeight;
          // @ts-ignore
          affirmativeLine.current.setAttribute('y1', `-${diff}`);
          // @ts-ignore
          fallbackLine.current.setAttribute('y1', `-${diff}`);
        } else {
          // @ts-ignore
          affirmativeLine.current.setAttribute('y1', `${0}`);
          // @ts-ignore
          fallbackLine.current.setAttribute('y1', `${0}`);
        }
      }
    }, 220)
  }} ref={levelNode} style={{ position: 'relative' }}>
    <LevelContainer>
      <div>
        {fallback ?
          <RenderNode node={fallback} type={"fallback"} deleteNode={deleteNode} updateNode={updateNode} level={level} />
          : fallback === null ? <AffirmationFallbackCreate background={redColor} type={"fallback"} onCreate={createNode} parentIdentifier={[level, 1]} /> : level > 0 && isViewOnly() && <Button style={{ color: 'red' }}
            type="link"
            onClick={() => { affirmative && createNode([affirmative?.identifier[0] - 1, affirmative?.identifier[1]], { type: 'fallback', values: null }) }}
          > Create fallback </Button>
        }
      </div>
      <div >
        <RenderNode updateNode={updateNode} node={affirmative} type={"affirmative"} deleteNode={deleteNode} level={level} />
      </div>
    </LevelContainer>
    <ArrowContainer style={{ display: nextAffirmative ? 'block' : 'none' }}>
      <svg width="144" height="102" viewBox="0 0 144 102" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line ref={affirmativeLine} x1="63" x2="63" y1="1" y2="1" stroke={greenColor} />
        <path d="M1.41335 51H0.24858L2.86577 43.7273H4.13352L6.75071 51H5.58594L3.52983 45.0483H3.47301L1.41335 51ZM1.60866 48.152H5.38707V49.0753H1.60866V48.152ZM10.2823 45.5455V46.3977H7.19993V45.5455H10.2823ZM8.0451 51V44.9134C8.0451 44.5724 8.11967 44.2895 8.26882 44.0646C8.41797 43.8374 8.61565 43.6681 8.86186 43.5568C9.10807 43.4432 9.37559 43.3864 9.66442 43.3864C9.87749 43.3864 10.0598 43.4041 10.2113 43.4396C10.3628 43.4728 10.4753 43.5036 10.5487 43.532L10.3001 44.3913C10.2504 44.3771 10.1864 44.3606 10.1083 44.3416C10.0302 44.3203 9.93549 44.3097 9.82422 44.3097C9.56617 44.3097 9.38151 44.3736 9.27024 44.5014C9.16134 44.6293 9.10689 44.8139 9.10689 45.0554V51H8.0451ZM13.9737 45.5455V46.3977H10.8913V45.5455H13.9737ZM11.7365 51V44.9134C11.7365 44.5724 11.8111 44.2895 11.9602 44.0646C12.1094 43.8374 12.3071 43.6681 12.5533 43.5568C12.7995 43.4432 13.067 43.3864 13.3558 43.3864C13.5689 43.3864 13.7512 43.4041 13.9027 43.4396C14.0542 43.4728 14.1667 43.5036 14.2401 43.532L13.9915 44.3913C13.9418 44.3771 13.8778 44.3606 13.7997 44.3416C13.7216 44.3203 13.6269 44.3097 13.5156 44.3097C13.2576 44.3097 13.0729 44.3736 12.9616 44.5014C12.8527 44.6293 12.7983 44.8139 12.7983 45.0554V51H11.7365ZM15.0692 51V45.5455H16.131V51H15.0692ZM15.6055 44.7038C15.4208 44.7038 15.2622 44.6423 15.1296 44.5192C14.9994 44.3937 14.9343 44.2446 14.9343 44.0717C14.9343 43.8965 14.9994 43.7474 15.1296 43.6243C15.2622 43.4988 15.4208 43.4361 15.6055 43.4361C15.7901 43.4361 15.9476 43.4988 16.0778 43.6243C16.2103 43.7474 16.2766 43.8965 16.2766 44.0717C16.2766 44.2446 16.2103 44.3937 16.0778 44.5192C15.9476 44.6423 15.7901 44.7038 15.6055 44.7038ZM17.5595 51V45.5455H18.5858V46.4119H18.6426C18.742 46.1184 18.9172 45.8875 19.1681 45.7195C19.4215 45.549 19.7079 45.4638 20.0275 45.4638C20.0938 45.4638 20.1719 45.4661 20.2619 45.4709C20.3542 45.4756 20.4264 45.4815 20.4785 45.4886V46.5043C20.4359 46.4924 20.3601 46.4794 20.2512 46.4652C20.1423 46.4486 20.0334 46.4403 19.9245 46.4403C19.6736 46.4403 19.4499 46.4936 19.2534 46.6001C19.0592 46.7043 18.9054 46.8499 18.7917 47.0369C18.6781 47.2216 18.6213 47.4323 18.6213 47.669V51H17.5595ZM21.3974 51V45.5455H22.4165V46.4332H22.484C22.5977 46.1326 22.7835 45.8982 23.0415 45.7301C23.2996 45.5597 23.6085 45.4744 23.9684 45.4744C24.333 45.4744 24.6384 45.5597 24.8846 45.7301C25.1332 45.9006 25.3166 46.1349 25.435 46.4332H25.4918C25.622 46.142 25.8292 45.91 26.1133 45.7372C26.3974 45.562 26.7359 45.4744 27.1289 45.4744C27.6237 45.4744 28.0273 45.6295 28.3398 45.9396C28.6547 46.2498 28.8121 46.7173 28.8121 47.3423V51H27.7504V47.4418C27.7504 47.0724 27.6497 46.8049 27.4485 46.6392C27.2473 46.4735 27.007 46.3906 26.7276 46.3906C26.382 46.3906 26.1133 46.4972 25.9215 46.7102C25.7298 46.9209 25.6339 47.192 25.6339 47.5234V51H24.5756V47.3743C24.5756 47.0784 24.4833 46.8404 24.2987 46.6605C24.114 46.4806 23.8737 46.3906 23.5778 46.3906C23.3765 46.3906 23.1907 46.4439 23.0202 46.5504C22.8522 46.6546 22.716 46.8002 22.6119 46.9872C22.5101 47.1742 22.4592 47.3909 22.4592 47.6371V51H21.3974ZM31.8226 51.1207C31.477 51.1207 31.1645 51.0568 30.8851 50.929C30.6058 50.7988 30.3844 50.6106 30.2211 50.3643C30.0601 50.1181 29.9796 49.8163 29.9796 49.4588C29.9796 49.151 30.0388 48.8977 30.1571 48.6989C30.2755 48.5 30.4353 48.3426 30.6365 48.2266C30.8378 48.1106 31.0627 48.023 31.3113 47.9638C31.5598 47.9046 31.8132 47.8596 32.0712 47.8288C32.3979 47.791 32.6631 47.7602 32.8667 47.7365C33.0703 47.7105 33.2182 47.669 33.3105 47.6122C33.4029 47.5554 33.449 47.4631 33.449 47.3352V47.3104C33.449 47.0002 33.3614 46.7599 33.1863 46.5895C33.0134 46.419 32.7554 46.3338 32.4121 46.3338C32.0546 46.3338 31.7729 46.4131 31.5669 46.5717C31.3633 46.728 31.2225 46.902 31.1444 47.0938L30.1465 46.8665C30.2649 46.535 30.4377 46.2675 30.665 46.0639C30.8946 45.858 31.1586 45.7088 31.4569 45.6165C31.7551 45.5218 32.0688 45.4744 32.3979 45.4744C32.6157 45.4744 32.8465 45.5005 33.0904 45.5526C33.3366 45.6023 33.5662 45.6946 33.7793 45.8295C33.9947 45.9645 34.1711 46.1574 34.3084 46.4084C34.4457 46.657 34.5144 46.9801 34.5144 47.3778V51H33.4775V50.2543H33.4348C33.3662 50.3916 33.2632 50.5265 33.1259 50.6591C32.9886 50.7917 32.8122 50.9018 32.5968 50.9893C32.3813 51.0769 32.1233 51.1207 31.8226 51.1207ZM32.0534 50.2685C32.347 50.2685 32.598 50.2105 32.8063 50.0945C33.017 49.9785 33.1768 49.8269 33.2857 49.6399C33.397 49.4505 33.4526 49.2481 33.4526 49.0327V48.3295C33.4147 48.3674 33.3413 48.4029 33.2324 48.4361C33.1259 48.4669 33.004 48.4941 32.8667 48.5178C32.7293 48.5391 32.5956 48.5592 32.4654 48.5781C32.3352 48.5947 32.2263 48.6089 32.1387 48.6207C31.9327 48.6468 31.7445 48.6906 31.574 48.7521C31.406 48.8137 31.271 48.9025 31.1692 49.0185C31.0698 49.1321 31.0201 49.2836 31.0201 49.473C31.0201 49.7358 31.1171 49.9347 31.3113 50.0696C31.5054 50.2022 31.7528 50.2685 32.0534 50.2685ZM38.4748 45.5455V46.3977H35.4954V45.5455H38.4748ZM36.2944 44.2386H37.3562V49.3984C37.3562 49.6044 37.387 49.7595 37.4485 49.8636C37.5101 49.9654 37.5894 50.0353 37.6864 50.0732C37.7859 50.1087 37.8936 50.1264 38.0096 50.1264C38.0948 50.1264 38.1694 50.1205 38.2333 50.1087C38.2972 50.0968 38.3469 50.0874 38.3825 50.0803L38.5742 50.9574C38.5127 50.9811 38.4251 51.0047 38.3114 51.0284C38.1978 51.0545 38.0558 51.0687 37.8853 51.071C37.6059 51.0758 37.3455 51.026 37.104 50.9219C36.8626 50.8177 36.6673 50.6567 36.5181 50.4389C36.369 50.2211 36.2944 49.9477 36.2944 49.6186V44.2386ZM39.6493 51V45.5455H40.7111V51H39.6493ZM40.1855 44.7038C40.0009 44.7038 39.8423 44.6423 39.7097 44.5192C39.5795 44.3937 39.5144 44.2446 39.5144 44.0717C39.5144 43.8965 39.5795 43.7474 39.7097 43.6243C39.8423 43.4988 40.0009 43.4361 40.1855 43.4361C40.3702 43.4361 40.5276 43.4988 40.6578 43.6243C40.7904 43.7474 40.8567 43.8965 40.8567 44.0717C40.8567 44.2446 40.7904 44.3937 40.6578 44.5192C40.5276 44.6423 40.3702 44.7038 40.1855 44.7038ZM46.8058 45.5455L44.8278 51H43.6914L41.7099 45.5455H42.8498L44.2312 49.7429H44.288L45.6658 45.5455H46.8058ZM49.9689 51.1101C49.4315 51.1101 48.9687 50.9953 48.5804 50.7656C48.1945 50.5336 47.8962 50.2081 47.6855 49.7891C47.4772 49.3677 47.373 48.8741 47.373 48.3082C47.373 47.7495 47.4772 47.2571 47.6855 46.831C47.8962 46.4048 48.1898 46.0722 48.5662 45.8331C48.945 45.594 49.3877 45.4744 49.8944 45.4744C50.2021 45.4744 50.5004 45.5253 50.7892 45.6271C51.0781 45.7289 51.3373 45.8887 51.5669 46.1065C51.7966 46.3243 51.9777 46.6072 52.1103 46.9553C52.2428 47.3009 52.3091 47.7211 52.3091 48.2159V48.5923H47.9732V47.7969H51.2686C51.2686 47.5175 51.2118 47.2701 51.0982 47.0547C50.9846 46.8369 50.8248 46.6652 50.6188 46.5398C50.4152 46.4143 50.1761 46.3516 49.9015 46.3516C49.6032 46.3516 49.3427 46.425 49.1202 46.5717C48.9 46.7161 48.7296 46.9055 48.6088 47.1399C48.4905 47.3719 48.4313 47.6241 48.4313 47.8963V48.5178C48.4313 48.8823 48.4952 49.1925 48.623 49.4482C48.7533 49.7038 48.9344 49.8991 49.1664 50.0341C49.3984 50.1667 49.6694 50.233 49.9796 50.233C50.1808 50.233 50.3643 50.2045 50.53 50.1477C50.6957 50.0885 50.839 50.0009 50.9597 49.8849C51.0804 49.7689 51.1728 49.6257 51.2367 49.4553L52.2417 49.6364C52.1612 49.9323 52.0167 50.1915 51.8084 50.4141C51.6025 50.6342 51.3432 50.8059 51.0307 50.929C50.7206 51.0497 50.3667 51.1101 49.9689 51.1101Z" fill="black" />
        <path d="M61.6429 101.35C61.8362 101.547 62.1528 101.55 62.35 101.357L65.5636 98.2071C65.7608 98.0138 65.764 97.6972 65.5707 97.5C65.3774 97.3028 65.0608 97.2996 64.8636 97.4929L62.0071 100.293L59.2071 97.4364C59.0138 97.2392 58.6972 97.236 58.5 97.4293C58.3028 97.6226 58.2996 97.9392 58.4929 98.1364L61.6429 101.35ZM62.5 0.995L61.5 100.995L62.5 101.005L63.5 1.005L62.5 0.995Z" fill={greenColor} />
      </svg>
      <svg style={{ display: nextFallback ? 'svg' : 'none' }} width="480" height="100" viewBox="0 0 480 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M475.646 99.3536C475.842 99.5488 476.158 99.5488 476.354 99.3536L479.536 96.1716C479.731 95.9763 479.731 95.6597 479.536 95.4645C479.34 95.2692 479.024 95.2692 478.828 95.4645L476 98.2929L473.172 95.4645C472.976 95.2692 472.66 95.2692 472.464 95.4645C472.269 95.6597 472.269 95.9763 472.464 96.1716L475.646 99.3536ZM475.5 50V99H476.5V50H475.5Z" fill={redColor} />
        <line x1="476" y1="50.5" y2="50.5" stroke={redColor} />
        <line ref={fallbackLine} x1="0.5" x2="0.5" y1="0" y2="50" stroke={redColor} />
        <path d="M199.799 38V30.7273H204.309V31.6719H200.896V33.8878H203.986V34.8288H200.896V38H199.799ZM207.141 38.1207C206.795 38.1207 206.483 38.0568 206.203 37.929C205.924 37.7988 205.703 37.6106 205.539 37.3643C205.378 37.1181 205.298 36.8163 205.298 36.4588C205.298 36.151 205.357 35.8977 205.475 35.6989C205.594 35.5 205.754 35.3426 205.955 35.2266C206.156 35.1106 206.381 35.023 206.63 34.9638C206.878 34.9046 207.132 34.8596 207.39 34.8288C207.716 34.791 207.981 34.7602 208.185 34.7365C208.389 34.7105 208.537 34.669 208.629 34.6122C208.721 34.5554 208.767 34.4631 208.767 34.3352V34.3104C208.767 34.0002 208.68 33.7599 208.505 33.5895C208.332 33.419 208.074 33.3338 207.73 33.3338C207.373 33.3338 207.091 33.4131 206.885 33.5717C206.682 33.728 206.541 33.902 206.463 34.0938L205.465 33.8665C205.583 33.535 205.756 33.2675 205.983 33.0639C206.213 32.858 206.477 32.7088 206.775 32.6165C207.074 32.5218 207.387 32.4744 207.716 32.4744C207.934 32.4744 208.165 32.5005 208.409 32.5526C208.655 32.6023 208.885 32.6946 209.098 32.8295C209.313 32.9645 209.489 33.1574 209.627 33.4084C209.764 33.657 209.833 33.9801 209.833 34.3778V38H208.796V37.2543H208.753C208.685 37.3916 208.582 37.5265 208.444 37.6591C208.307 37.7917 208.131 37.9018 207.915 37.9893C207.7 38.0769 207.442 38.1207 207.141 38.1207ZM207.372 37.2685C207.665 37.2685 207.916 37.2105 208.125 37.0945C208.335 36.9785 208.495 36.8269 208.604 36.6399C208.715 36.4505 208.771 36.2481 208.771 36.0327V35.3295C208.733 35.3674 208.66 35.4029 208.551 35.4361C208.444 35.4669 208.322 35.4941 208.185 35.5178C208.048 35.5391 207.914 35.5592 207.784 35.5781C207.654 35.5947 207.545 35.6089 207.457 35.6207C207.251 35.6468 207.063 35.6906 206.892 35.7521C206.724 35.8137 206.589 35.9025 206.488 36.0185C206.388 36.1321 206.338 36.2836 206.338 36.473C206.338 36.7358 206.435 36.9347 206.63 37.0696C206.824 37.2022 207.071 37.2685 207.372 37.2685ZM212.309 30.7273V38H211.247V30.7273H212.309ZM214.799 30.7273V38H213.737V30.7273H214.799ZM216.313 38V30.7273H217.374V33.4297H217.438C217.5 33.3161 217.589 33.1847 217.705 33.0355C217.821 32.8864 217.982 32.7562 218.188 32.6449C218.394 32.5312 218.666 32.4744 219.004 32.4744C219.445 32.4744 219.838 32.5857 220.183 32.8082C220.529 33.0308 220.8 33.3516 220.997 33.7706C221.195 34.1896 221.295 34.6939 221.295 35.2834C221.295 35.8729 221.197 36.3783 221 36.7997C220.804 37.2187 220.534 37.5419 220.191 37.7692C219.847 37.9941 219.455 38.1065 219.015 38.1065C218.684 38.1065 218.413 38.0509 218.202 37.9396C217.994 37.8284 217.83 37.6982 217.712 37.549C217.593 37.3999 217.502 37.2673 217.438 37.1513H217.35V38H216.313ZM217.353 35.2727C217.353 35.6562 217.409 35.9924 217.52 36.2812C217.631 36.5701 217.792 36.7962 218.003 36.9595C218.214 37.1205 218.472 37.201 218.777 37.201C219.094 37.201 219.36 37.117 219.573 36.9489C219.786 36.7784 219.947 36.5476 220.056 36.2564C220.167 35.9652 220.222 35.6373 220.222 35.2727C220.222 34.9129 220.168 34.5897 220.059 34.3033C219.953 34.0168 219.792 33.7907 219.576 33.625C219.363 33.4593 219.097 33.3764 218.777 33.3764C218.469 33.3764 218.209 33.4557 217.996 33.6143C217.785 33.773 217.625 33.9943 217.517 34.2784C217.408 34.5625 217.353 34.8939 217.353 35.2727ZM224.075 38.1207C223.729 38.1207 223.416 38.0568 223.137 37.929C222.858 37.7988 222.636 37.6106 222.473 37.3643C222.312 37.1181 222.232 36.8163 222.232 36.4588C222.232 36.151 222.291 35.8977 222.409 35.6989C222.527 35.5 222.687 35.3426 222.888 35.2266C223.09 35.1106 223.315 35.023 223.563 34.9638C223.812 34.9046 224.065 34.8596 224.323 34.8288C224.65 34.791 224.915 34.7602 225.119 34.7365C225.322 34.7105 225.47 34.669 225.562 34.6122C225.655 34.5554 225.701 34.4631 225.701 34.3352V34.3104C225.701 34.0002 225.613 33.7599 225.438 33.5895C225.265 33.419 225.007 33.3338 224.664 33.3338C224.307 33.3338 224.025 33.4131 223.819 33.5717C223.615 33.728 223.474 33.902 223.396 34.0938L222.398 33.8665C222.517 33.535 222.69 33.2675 222.917 33.0639C223.147 32.858 223.411 32.7088 223.709 32.6165C224.007 32.5218 224.321 32.4744 224.65 32.4744C224.868 32.4744 225.098 32.5005 225.342 32.5526C225.589 32.6023 225.818 32.6946 226.031 32.8295C226.247 32.9645 226.423 33.1574 226.56 33.4084C226.698 33.657 226.766 33.9801 226.766 34.3778V38H225.729V37.2543H225.687C225.618 37.3916 225.515 37.5265 225.378 37.6591C225.241 37.7917 225.064 37.9018 224.849 37.9893C224.633 38.0769 224.375 38.1207 224.075 38.1207ZM224.305 37.2685C224.599 37.2685 224.85 37.2105 225.058 37.0945C225.269 36.9785 225.429 36.8269 225.538 36.6399C225.649 36.4505 225.705 36.2481 225.705 36.0327V35.3295C225.667 35.3674 225.593 35.4029 225.484 35.4361C225.378 35.4669 225.256 35.4941 225.119 35.5178C224.981 35.5391 224.848 35.5592 224.717 35.5781C224.587 35.5947 224.478 35.6089 224.391 35.6207C224.185 35.6468 223.996 35.6906 223.826 35.7521C223.658 35.8137 223.523 35.9025 223.421 36.0185C223.322 36.1321 223.272 36.2836 223.272 36.473C223.272 36.7358 223.369 36.9347 223.563 37.0696C223.757 37.2022 224.005 37.2685 224.305 37.2685ZM230.478 38.1101C229.95 38.1101 229.496 37.9905 229.115 37.7514C228.736 37.5099 228.445 37.1773 228.241 36.7536C228.037 36.3298 227.936 35.8445 227.936 35.2976C227.936 34.7436 228.04 34.2547 228.248 33.831C228.456 33.4048 228.75 33.0722 229.129 32.8331C229.508 32.594 229.954 32.4744 230.468 32.4744C230.882 32.4744 231.251 32.5514 231.575 32.7053C231.9 32.8568 232.161 33.0698 232.36 33.3445C232.561 33.6191 232.681 33.9399 232.719 34.3068H231.686C231.629 34.0511 231.499 33.831 231.295 33.6463C231.094 33.4616 230.824 33.3693 230.485 33.3693C230.189 33.3693 229.93 33.4474 229.708 33.6037C229.487 33.7576 229.316 33.9777 229.193 34.2642C229.07 34.5483 229.008 34.8845 229.008 35.2727C229.008 35.6705 229.068 36.0137 229.189 36.3026C229.31 36.5914 229.48 36.8151 229.7 36.9737C229.923 37.1323 230.185 37.2116 230.485 37.2116C230.686 37.2116 230.869 37.175 231.032 37.1016C231.198 37.0258 231.336 36.9181 231.448 36.7784C231.561 36.6387 231.641 36.4706 231.686 36.2741H232.719C232.681 36.6269 232.566 36.9418 232.374 37.2188C232.183 37.4957 231.926 37.7135 231.604 37.8722C231.284 38.0308 230.909 38.1101 230.478 38.1101ZM234.831 36.1499L234.824 34.8537H235.009L237.182 32.5455H238.453L235.974 35.1733H235.808L234.831 36.1499ZM233.854 38V30.7273H234.916V38H233.854ZM237.299 38L235.346 35.4077L236.077 34.6655L238.602 38H237.299Z" fill="black" />
      </svg>
    </ArrowContainer>
  </div>
}

export default JourneyLevel;